import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import { appConfig } from 'config';

const getServiceEndpoint = (service, format) => `${appConfig.apiBaseUrl}/${service}/info?format=${format}`;

export const getChangeLogs = (service, format = 'json', env = null) => {
  // env can be 'dev', 'staging', 'verizon1', or 'prod'
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  const requestOptions = {
    headers: headers,
    redirect: 'follow',
    method: 'GET'
  };

  const endpoint = env
    ? `https://ibms-${env}.azure-api.net/${service}/info?format=${format}`
    : getServiceEndpoint(service, format);

  return fetchdata(endpoint, { ...requestOptions }).catch((e) => {
    console.log('fetch data error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e.message;
    }
  });
};
